import React, { useState } from "react";
import UsersTableView from "./UsersTableView";

const UserDashboard = () => {
    return <UsersTableView></UsersTableView>;
};

export default UserDashboard;
